/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';

export const candidateReputationSchema: z.AnyZodObject = z.object({
  aggTopTenPercent: z.boolean().nullish(),
  averageClientRecommendScore: z.number().nullish(),
  businessJudgementScore: z.number().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid(),
  communicationScore: z.number().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  legalExpertiseScore: z.number().nullish(),
  numberOfAxiomEngagements: z.number().int(),
  numberOfEngagements: z.number().int(),
  numberOfRespondents: z.number().int(),
  numberOfReviews: z.number().int(),
  numberOfTestimonials: z.number().int(),
  percentMetExpectations: z.number().nullish(),
  percentageOfReEngagements: z.number().nullish(),
  reputationSummary: z.string().nullish(),
  responsivenessScore: z.number().nullish(),
  updatedAt: z.string().datetime().nullish(),
  yearsAtAxiom: z.number(),
});

export type CandidateReputation = z.infer<typeof candidateReputationSchema>;
